module.exports = __webpack_public_path__ + "media/images/lb/060-2cf46587e8a79daa8017ffa625fee955.svg";